import {
  scrollTo,
  setDocumentTitle,
  replaceInnerHtml,
  getLazyLoadInstance,
  getElementOffsetTop,
  dispatchCustomEventGlobally,
} from 'www/utils'
import { POPUP_MAP_EVENTS, SCROLL_TO_OPTIONS } from 'www/constants'
import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import type { ApiLpuListResponseGet } from 'www/vue_components/common/TheFilters/lpu/api/apiLpuList.types'

const lazyLoadInstance = window.MOBILE_VERSION ? getLazyLoadInstance() : null

function populatePageWithNewData(data: ApiLpuListResponseGet) {
  const commonStore = useCommonStore()

  setDocumentTitle(data.title)
  replaceInnerHtml(commonStore.domNodes.list, data.appointments_page)

  if (data.description) {
    replaceInnerHtml(commonStore.domNodes.headTitle, data.head_title)
    replaceInnerHtml(commonStore.domNodes.description, data.description)
  }

  if (data.lpu_ad) {
    replaceInnerHtml(commonStore.domNodes.lpuAd, data.lpu_ad)
    dispatchCustomEventGlobally('executeLpuAdScript')
  }

  if (data.information) {
    replaceInnerHtml(commonStore.domNodes.lpuListInfo, data.information)
  }

  if (!window.MOBILE_VERSION) {
    replaceInnerHtml(commonStore.domNodes.pagination, data.paginator)
    replaceInnerHtml(commonStore.domNodes.breadcrumbs, data.bread)
  }

  if (window.MOBILE_VERSION) {
    document.dispatchEvent(new Event('refresh_slots'))
    document.dispatchEvent(new Event('set_toggle_action'))
    document.dispatchEvent(new Event('updateYandexMapModal'))

    dispatchCustomEventGlobally(POPUP_MAP_EVENTS.mounted)
  } else {
    document.dispatchEvent(new Event('updateLpuSchedule'))
  }

  document.dispatchEvent(new Event('refreshInit'))
  document.dispatchEvent(new Event('initSlider'))
  document.dispatchEvent(new Event('content-replace'))
  document.dispatchEvent(new Event('get-doctor-spec'))
  document.dispatchEvent(new Event('initClubInfoBanner'))

  document.dispatchEvent(new Event('mountLpuLoyaltyProgram'))

  const scrollTarget = document.querySelector(commonStore.domNodes.scrollTarget)

  if (scrollTarget) {
    scrollTo(
      getElementOffsetTop(scrollTarget),
      SCROLL_TO_OPTIONS,
    )
  }

  if (window.MOBILE_VERSION) {
    lazyLoadInstance?.update()
  }
}

export default populatePageWithNewData
